import { useUpdateEffect } from '@cian/react-utils';

import { useRef } from 'react';

import { useUpdateChangedClusters } from '@/microfrontends/map/shared/hooks/useUpdateChangedClusters';

import { useGetClustersQuery } from '@/packages/query-state/shared/store/search-offers-index/v2/get-clusters-for-map/query';
import { clustersSelector } from '@/packages/query-state/shared/store/search-offers-index/v2/get-clusters-for-map/selectors';
import { type Cluster } from '@/packages/query-state/shared/types/clusters/ClustersResponse';
import {
  useActivePinIdSelector,
  useHoveredPinIdSelector,
} from '@/packages/redux-state/store/slices/mapControls/selectors/dumb';

export const useTrackHoveredPinChanged = (): void => {
  const hoveredPinId = useHoveredPinIdSelector();
  const updateChangedClusters = useUpdateChangedClusters();
  const { data: clusters } = useGetClustersQuery({ select: clustersSelector });

  const activePinId = useActivePinIdSelector();
  const previousHoveredPinIdRef = useRef<string>();

  /**
   * @description
   * Обрабатываем mouseleave на пине, удаляя свойство hovered
   */
  useUpdateEffect(() => {
    const previousHoveredPinId = previousHoveredPinIdRef.current;

    if (!previousHoveredPinId || !clusters) {
      return;
    }

    const unhoveredCluster = clusters.find(item => item.id === previousHoveredPinId) as Cluster;

    if (unhoveredCluster) {
      delete unhoveredCluster.properties?.hovered;

      updateChangedClusters(unhoveredCluster);
    }

    previousHoveredPinIdRef.current = undefined;
  }, [hoveredPinId, clusters, updateChangedClusters]);

  /**
   * @description
   * Обрабатываем mouseenter на пине, добавляя свойство hovered
   */
  useUpdateEffect(() => {
    const previousHoveredPinId = previousHoveredPinIdRef.current;

    if (previousHoveredPinId || !hoveredPinId || !clusters) {
      return;
    }

    const hoveredCluster = clusters.find(item => item.id === hoveredPinId) as Cluster;

    if (hoveredCluster) {
      hoveredCluster.properties ??= {};
      hoveredCluster.properties.hovered = 1;

      updateChangedClusters(hoveredCluster);

      previousHoveredPinIdRef.current = hoveredPinId;
    }
  }, [hoveredPinId, clusters, updateChangedClusters]);

  useUpdateEffect(() => {
    if (activePinId && activePinId === hoveredPinId) {
      previousHoveredPinIdRef.current = undefined;
    }
  }, [activePinId, hoveredPinId]);
};
